export default [
    {
        path: '/indexOnly',
        name: 'indexOnly',
        component: () => import('@/views/patrol/patrolcompile/PageControlOnly/indexOnly.vue'),
    },
    {
        path: '/patrolHome',
        name: 'PatrolHome',
        component: () => import('@/views/patrol/patrolHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/patrolcompile',
        name: 'patrolcompile',
        component: () => import('@/views/patrol/patrolcompile/index.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/patrollssue',
        name: 'patrollssue',
        component: () => import('@/views/patrol/patrollssue/index.vue'),
    },
    // {
    //     path: '/patroldistribute',
    //     name: 'patroldistribute',
    //     component: () => import('@/views/evaluateServe/evaluateIssue/distribute.vue'),
    // },
    // {
    //     path: '/patroldetailsHome',
    //     name: 'patroldetailsHome',
    //     component: () => import('@/views/evaluateServe/evaluateDetails/detailsHome.vue'),
    // },
    //人员操作详情
    {
        path: '/patrolpersonnelOperation',
        name: 'patrolpersonnelOperation',
        component: () => import('@/views/patrol/scoringDetails/personnelOperation.vue'),
    },
    //发布评论
    {
        path: '/patrolpostcomments',
        name: 'patrolpostcomments',
        component: () => import('@/views/patrol/publish/postcomments.vue'),
    },
    //下载
    {
        path: '/patroldownload',
        name: 'patroldownload',
        component: () => import('@/views/patrol/common/download.vue'),
    },
    //生成
    {
        path: '/patrolcreate',
        name: 'patrolcreate',
        component: () => import('@/views/patrol/common/create.vue'),
    },
    //数据来源source
    {
        path: '/patrolsource',
        name: 'patrolsource',
        component: () => import('@/views/patrol/common/source.vue'),
    },
    //选择参与设备
    {
        path: '/patroldevices',
        name: 'patroldevices',
        component: () => import('@/views/patrol/common/devices.vue'),
    },


    //merge，数据合并审核

    {
        path: '/patrolmerge',
        name: 'patrolmerge',
        component: () => import('@/views/patrol/patrolmerge/index.vue'),
    },

    //merge，数据合并审核(只读)

    {
        path: '/patrolmergereadonly',
        name: 'patrolmergereadonly',
        component: () => import('@/views/patrol/patrolmerge/PageControlOnly/indexOnly.vue'),
    },
]
